import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import Modal from 'react-modal';
import { compose } from 'recompose';
import windowSize from 'react-window-size';
import moment from "moment";

import { distanceMeters, METERS_TO_MILES, spaceBeforeNewLine } from "../../helper_functions";
import { moveClue, deleteClue, selectClue, fetchClueIcons } from "../../actions/index";
import { ClueNavButton, DELETE, MOVE_DOWN, MOVE_UP } from "./ClueNavButton";
import { ConfirmDelete } from "../huntcomponents/dialogs";
import { FormattedLabelsAndValues } from "../huntcomponents/FormattedLabelsAndValues";
import BoundsOnMap from "../huntedit/BoundsOnMap";
import { getIconUrl } from "./ClueIconChooser";
import { BOUNDS, GAME_TYPE, GAME_TYPE_CODE, GAME_TYPE_TIME, LAST_MODIFIED } from "../../constants/Game";
import { ANSWER_PHOTO, ANSWER_THUMB, CLUE_LATLON, THUMB } from "../../constants/Clue";

import '../../global.css';
import './EditCluesPage.css';

/**
 * The main presentation of the list of clues.  For editing and analyzing list of clues.
 * This is not a top level component -- does not do authorization.
 * Use this only with another page that is authorized.
 * Currently contained within huntedit.GameDetail, and huntwizard.WizardClues page.
 */
class MainClueList extends Component  {
    constructor(props) {
        super(props);

        this.state = {
            deleteConfirmIsOpen: false,
            indexSelected: -1
        };

        this.clueNavSelected = this.clueNavSelected.bind(this);
        this.deleteClue = this.deleteClue.bind(this);
        this.openDeleteModal = this.openDeleteModal.bind(this);
        this.closeDeleteModal = this.closeDeleteModal.bind(this);

        // clear out any currently selected clue from global state.
        this.props.selectClue(null);
    }

    // Go to the edit page for the clue at the selected index
    editSelected(index) {
        const { game } = this.props;
        const clue = game.clues[index];

        this.props.selectClue(clue);
        this.props.history.push(`/games/${this.id()}/clues/edit/${index}`);
    }

    // A button within the clue items was selected.
    clueNavSelected(e, nav) {
        const { index } = e.currentTarget.dataset;
        const { game } = this.props;
        game.id = this.id();

        if (nav === MOVE_UP || nav === MOVE_DOWN) {
            this.props.moveClue(game, index, nav, () => {});
        }

        if (nav === DELETE) {
            this.openDeleteModal(index);
        }

        e.stopPropagation();
    }

    openDeleteModal(index) {
        this.setState({deleteConfirmIsOpen: true, indexSelected: index});
    }

    closeDeleteModal() {
        this.setState({deleteConfirmIsOpen: false, indexSelected: -1}
        );
    }

    deleteClue() {
        const { deleteClue, game } = this.props;
        const { indexSelected } = this.state;
        game.id = this.id();

        deleteClue(game, indexSelected, () => { } );
        this.closeDeleteModal()
    }

    // generate and return all the stats from the array of clues
    statsFromClues(clues) {
        const duration = this.calculateDuration(clues);
        const distance = this.calculateDistance(clues) + " miles";
        const totalCount = clues ? clues.length : 0;
        let durationCount = 0;
        let codedCount = 0;
        let codes = "";

        if (clues) {
            clues.forEach((clue) => {
                if (clue.duration_sec || clue.duration_min) {
                    durationCount++;
                }
                if (clue.code && clue.code.length > 0) {
                    codedCount++;
                    codes = codes + clue.code + " | ";
                }
            });
        }
        if (codes.length > 1) {
            codes = codes.substr(0, codes.length-2);
        }

        // cluesStats
        return {totalCount: totalCount, durationCount: durationCount, duration: duration,
            codedCount: codedCount, codes: codes, distance: distance }
    }

    // array of the bounds
    boundsFromClues(clues) {
        return clues.map( (clue) => {return clue.boundingBox})
    }

   // array of the icons
   iconsFromClues(clues) {
      return clues.map((clue) => {
         return clue.icon
      })
   }

   // array of the picture clues
   picturesFromClues(clues) {
      return clues.map((clue) => {
         return clue.clue_picture
      })
   }

   // array of the answers
   answerPhotosFromClues(clues) {
      return clues.map((clue) => {
         return clue.answer_photo
      })
   }

   // count all the non-null elements in an array.
   countArray(theArray) {
      let count = 0;
      for (let i = 0; i < theArray.length; i++) {
         if (theArray[i]) count++;
      }
      return count;
   }

   // size of the map at the top right of the component
   calculateMapThumbDimensions() {

      const minDimensions = {width: 216, height: 178};
      const {windowWidth} = this.props;

      const width = Math.max(windowWidth * 29 / 100, minDimensions.width);
      const height = Math.max(windowWidth * 22 / 100, minDimensions.height);

      return {width, height}
   }

    // total distance in miles of the path between the clue answers.
    calculateDistance(clues) {

        if (!clues || clues.length < 2) return 0.0;
        let previousLatLon = clues[0][CLUE_LATLON];

        let totalDistanceMeters = 0.0;

        for (let i=1; i < clues.length; i++) {
            const latLon = clues[i][CLUE_LATLON];
            if (!latLon) continue;

            if (!!previousLatLon) {
                totalDistanceMeters += distanceMeters(previousLatLon, latLon);
            }
            previousLatLon = latLon;
        }
        return (totalDistanceMeters * METERS_TO_MILES).toFixed(2);
    }

    // adds up all the clue durations (for those clues that have it)
    calculateDuration(clues) {
        if (!clues) {
            return 0;
        }

        let sum = 0;

        clues.forEach((clue) => {
            if (clue.duration_min) {
                sum += clue.duration_min;
            }
            else if (clue.duration_sec) {
                sum += Math.round(clue.duration_sec/60)
            }
        });
        const minutes = sum;
        if (minutes < 120) {
            return `${minutes} minutes`;
        }
        const hours = Math.floor(minutes/60);
        const minRem = minutes%60;
        if (minRem === 0) {
            return `${hours} hours`;
        }
        return `${hours} hours, ${minRem} min`;
    }

    // helper to grab the game id
    id() {
        return this.props.match.params.id;
    }

    // helper to grab the game
    game() {
       return this.props.game
    }

    // helper to grab the clues
    clues() {
        return this.game().clues
    }

    // react-router Link component for our new clue page for current game
    newClueLink() {
        return (
            <Link
                to={`/games/${this.id()}/clues/edit`}
                className="btn btn-default primary-link"
            >
                Add Clue
            </Link>
        );
    }

    // Render all the individual clues.  The heart of this component.
    renderList(clues, editable) {

        let index = 0;
        // if global clue icons not yet present, fetch them for us.
        if (!this.props.clueIcons) {
            fetchClueIcons()
        }

        if (!clues) {
            return <div>No clues</div>
        }

        // For each clue
        return clues.map((clue) => {

            const { title, clue_text, duration_min, duration_sec, code, boundingBox } = clue;

            clue.index = index;
            const titleText = title ? title : "";
            const hasUp = (index !== 0) && editable;
            index++;
            const hasDown = (index !== clues.length) && editable;

            const hasBounds = !!boundingBox;
            const iconUrl = getIconUrl(this.props.clueIcons, clue, null, false);

           const clueThumb = clue[THUMB];
           const answerPhoto = clue[ANSWER_PHOTO];
           const answerThumb = clue[ANSWER_THUMB];

           const hasPicture = !!clueThumb;
           const hasAnswerPhoto = !!answerPhoto;

           const groupItemClass = editable
              ? "list-group-item flex-column selectable"
              : "list-group-item flex-column"
           const onClick = editable ? () => this.editSelected(clue.index) : () => { };

           return (
              <div
                 key={clue_text}
                 onClick={onClick}
                 className={groupItemClass}
              >
                 <div className="bottom-margin">
                    <div className="pull-right">
                       {hasUp &&
                       <ClueNavButton
                          text="Move up" type={MOVE_UP} iconName="arrow-up" index={index} nav={this.clueNavSelected}
                       />
                       }
                       {hasDown &&
                       <ClueNavButton
                          text="Move down" type={MOVE_DOWN} iconName="arrow-down" index={index}
                          nav={this.clueNavSelected}
                       />
                       }
                       {editable &&
                       <ClueNavButton
                          text="Delete" type={DELETE} iconName="trash" index={index} nav={this.clueNavSelected}
                          isDanger={true}
                       />
                       }
                    </div>
                    <div className="top-padding"><strong>Clue #{index.toString()} </strong>
                       <span className="left-margin light-text right-margin"><i>{titleText}</i></span>
                       {!hasBounds && <span className="red-text left-margin"> (No location) </span>}
                    </div>
                 </div>
                 <div>
                    {!!iconUrl &&
                    <div className="pull-right thumbnail col-xs-2 col-sm-2 col-md-2">
                       <img src={iconUrl} alt="clue icon"/>
                    </div>
                    }

                    <div>
                       {hasPicture &&
                       <img className="picture-thumb" src={clueThumb} alt="thumbnail of clue pixture"/>
                       }

                       <p className="user">{spaceBeforeNewLine(clue_text)}</p>

                       {duration_min && (
                          <div className="top-padding"> Duration: <b> {duration_min} </b> minutes</div>
                       )}

                       {!duration_min && duration_sec && (
                          <div className="top-padding"> Duration: <b> {duration_sec} </b> seconds</div>
                       )}

                       {code && (
                          <div className="top-padding clear-left">
                             <span> Answer code: <b> {code} </b> </span>
                             {hasAnswerPhoto &&
                             <img className="answer-thumb" src={answerThumb} alt="thumbnail of foto showing answer"/>}
                          </div>
                       )}
                    </div>

                    {/* Fix for icon falling out of box for small, single-line clue text */}
                    <div className="clear-all"></div>
                 </div>
              </div>
           );
        });
    }

    render() {
        const { game, isWizard, editable } = this.props;

        // Still no game?
        if (!game) {
            return <div> Error: No game </div>
        }

        const clues = game.clues;

       // old duration code is still in here.  It may be applicable, i.e. its possible to have no code but to
       // have a duration
        const isCodeOnly = game[GAME_TYPE] === GAME_TYPE_CODE;
        const isDurationOnly = game[GAME_TYPE] === GAME_TYPE_TIME;
        const isMixed = !isCodeOnly && !isDurationOnly;

        const clueStats = this.statsFromClues(clues);
        const lastModifiedDate = game[LAST_MODIFIED];

        const lastModified = lastModifiedDate ?
            moment(lastModifiedDate.toDate()).format("MMM Do YYYY HH:mm") :
            "Unknown";

        // Table at top of label: value
        let labels = [];
        let values = [];
        labels.push(       "Number");  values.push(clueStats.totalCount);
        if (isMixed) {
            labels.push("Time Release Clues");  values.push(clueStats.durationCount);
            labels.push( "Answer Code Clues");  values.push(clueStats.codedCount);
        }
        if (isCodeOnly || isMixed) {
            labels.push(                     "Answers");  values.push(clueStats.codes);
        }
        if (isDurationOnly || isMixed) {
            labels.push(              "Total duration");  values.push(clueStats.duration);
        }

        labels.push("Distance"); values.push(clueStats.distance);

        if (!isWizard) {
            labels.push(                 "Last Edited");  values.push(lastModified);
        }

        const hasClues = clues && clues.length > 0
        const hasClueBounds = clues && clues.length > 0 && !!game.bounding_box;
        const dims = this.calculateMapThumbDimensions();
        const gameBounds = game[BOUNDS];
        const boundsArray = hasClueBounds ? this.boundsFromClues(clues) : null;
        const clueBoundsCount = hasClueBounds ? this.countArray(boundsArray) : 0;
        const clueBoundsExplanation = hasClueBounds
           ? clueBoundsCount.toString() + " of " + clues.length.toString() + " clues have map locations."
           : "0 of 0 clues have map locations.";
       const iconCountText = hasClues
          ? this.countArray(this.iconsFromClues(clues)).toString() + " of " + clues.length.toString() + " clues have chosen icons."
          : "0 of 0 clues have chosen icons.";
       const pictureCountText = hasClues
          ? this.countArray(this.picturesFromClues(clues)).toString() + " of " + clues.length.toString() + " clues have pictures."
          : "0 of 0 clues have pictures.";  // change to "picture clues".
       const answerPhotoCountText = hasClues
          ? this.countArray(this.answerPhotosFromClues(clues)).toString() + " of " + clues.length.toString() + " clues have answer photos."
          : "0 of 0 clues have answer photos.";

       const mapClueSelectionCallback = editable
         ? (clueNumber) => { this.editSelected(clueNumber - 1) }
         : (_) => { }

       return (
          <div className='bottom-margin'>

             <div className="pull-right clear-right col-xs-12 col-sm-4 col-md-4 bottom-margin">

             {!!gameBounds &&
             <h5 className="bottom-margin">
                Clue bounds in hunt
             </h5>
             }

             {!!gameBounds &&
             <div className="align-center left-margin top-margin">
                <BoundsOnMap
                   bounds={gameBounds}
                   height={dims.height}
                   width={dims.width}
                   hasDefaultLatLon={false}
                   editable={false}
                   subBounds={boundsArray}
                   subBoundsCallback={mapClueSelectionCallback}
                   caption=""/>
             </div>
             }
             </div>

             <div className="">
                <h3 className="inline secondary-highlight">
                   Clues
                   {editable ?
                      <Link to={`/games/${this.id()}/clues/edit`} className="btn btn-link left-margin edit-button accent-link">
                         (Add)
                      </Link>
                      : ""}
                </h3>
             </div>

             <div className="top-padding col-xs-12 col-sm-7 col-md-7 ">
                <FormattedLabelsAndValues className="min-width-table" labels={labels} values={values}/>
             </div>

             <div className="one-and-onehalf-top-margin col-xs-12 col-sm-7 col-md-7 small-bottom-margin">
                <div>
                   <i className="larger-font far fa-map right-margin"> </i>
                   <span className="secondary-highlight">{clueBoundsExplanation}</span>
                </div>
                <div>
                   <i className="larger-font top-margin-quarter fa fa-icons right-margin"> </i>
                   <span className="secondary-highlight">{iconCountText}</span>
                </div>
                <div>
                   <i className="larger-font top-margin-quarter fa fa-image right-margin"> </i>
                   <span className="secondary-highlight">{pictureCountText}</span>
                </div>
                <div>
                   <i className="larger-font top-margin-quarter fa fa-camera right-margin"> </i>
                   <span className="secondary-highlight">{answerPhotoCountText}</span>
                </div>
             </div>

             <br className="clear-all"/>

             <div className="list-group clue-list col-sm-11 col-md-10 col-lg-9">
                {this.renderList(clues, editable)}

                {editable &&
                <div className="top-margin">
                   {this.newClueLink()}
                </div>
                }
             </div>

             {/*Pop up to confirm delete of individual clue.*/}
             <Modal
                isOpen={this.state.deleteConfirmIsOpen}
                onRequestClose={this.closeDeleteModal}
                className="confirm-modal-content"
                overlayClassName="my-modal-overlay"
             >
                <ConfirmDelete
                   title="Delete Clue"
                   message="Are you sure you want to permanantly delete this clue?"
                   confirmText="Delete"
                   onConfirm={this.deleteClue}
                   closeModalCallback={this.closeDeleteModal}
                />
             </Modal>
          </div>
       )
    }
}

// boilerplate redux, tie in our app state to props
function mapStateToProps(state) {
    return {
        clueIcons: state.clueIcons
    };
}

export default compose(
    connect(mapStateToProps, { moveClue, deleteClue, selectClue } ),
    withRouter,
    windowSize
)(MainClueList);



// WEBPACK FOOTER //
// ./src/components/clues/MainClueList.js